import i18n from '@/i18n';

const LOCALES: Record<string, string> = { uz: 'uz-UZ', ru: 'ru-RU', en: 'en-US' };

/** BCP-47 locale for Intl/toLocale* following the active UI language. */
export function intlLocale(): string {
  return LOCALES[i18n.language] ?? 'uz-UZ';
}
